const changeVersion = {
  namespaced: true,
  state: {
    changeFlag: localStorage.getItem('changeFlag') ? Boolean(localStorage.getItem('changeFlag')) : false, // 版本切换
    changeWord: localStorage.getItem('changeFlagWord') ? localStorage.getItem('changeFlagWord') : '地方版',
    jumpPage: 0 // 登录成功之后跳转到对应的页面
  },
  mutations: {
    setChangeFlag: (state, key) => {
      state.changeFlag = key
    },
    setChangeFlagWord: (state, key) => {
      state.changeWord = key
    }
  }
}

export default changeVersion
